// import { useState, useEffect } from "react";
// import WithFieldData from "../HOK/withFieldData";
// import SmallProductCart from "../standartComponent/productComponent/smallProductCart";
// import css from "./main.module.css";
// import { useNavigate } from "react-router-dom";
// import { useDispatch } from "react-redux";
// import { addFilter } from "../../function/filtersSlice";
// const OneProdActions = ({ products, setCartCounterC, setLikeCounterC }) => {
//   const [randomProduct, setRandomProduct] = useState(null);
//   const navigate = useNavigate();
//   const dispatch = useDispatch();
//   useEffect(() => {
//     if (products.length > 0) {
//       const randomIndex = Math.floor(Math.random() * products.length);
//       setRandomProduct(products[randomIndex]);
//     }
//   }, [products]);
//   const goToSales = () => {
//     // Додаємо фільтр "Акція" в Redux
//     dispatch(addFilter({ field: "sale", value: "true" }));
//     // Перенаправляємо на сторінку каталогу
//     navigate("/catalog");
//   };
//   return (
//     <div className={css.oneProdWrapNew}>
//       <p className={css.nameOfAcr} onClick={goToSales}>
//         Всі Акції
//       </p>
//       {randomProduct && (
//         <SmallProductCart
//           el={randomProduct}
//           setCartCounterC={setCartCounterC}
//           setLikeCounterC={setLikeCounterC}
//         />
//       )}
//     </div>
//   );
// };

// export default WithFieldData("sale", "product", "true")(OneProdActions);
import { useState, useEffect } from "react";
import SmallProductCart from "../standartComponent/productComponent/smallProductCart";
import css from "./main.module.css";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { addFilter } from "../../function/filtersSlice";
import { db } from "../../firebase";
import { getDocs, collection } from "firebase/firestore";
import WithFieldData from "../HOK/withFieldData";

const OneProdActions = ({
  products: saleProducts, // приходить з WithFieldData("sale", "product", "true")
  setCartCounterC,
  setLikeCounterC,
}) => {
  const [allProducts, setAllProducts] = useState([]); // усі товари для перевірки акцій
  const [actions, setActions] = useState([]); // усі акції
  const [randomProduct, setRandomProduct] = useState(null); // вибраний випадковий товар

  const navigate = useNavigate();
  const dispatch = useDispatch();

  // 1️⃣ Підтягуємо ВСІ товари + акції
  useEffect(() => {
    const fetchAllProducts = async () => {
      const snapshot = await getDocs(collection(db, "product"));
      const list = snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
      setAllProducts(list);
    };

    const fetchActions = async () => {
      const snapshot = await getDocs(collection(db, "actions"));
      const list = snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
      console.log("list", list);

      setActions(list);
    };

    fetchAllProducts();
    fetchActions();
  }, []);

  // 2️⃣ Коли є усі товари та акції → перевіряємо хто підпадає під акцію
  // useEffect(() => {
  //   if (allProducts.length && actions.length) {
  //     const now = new Date();

  //     // фільтрація товарів які під акцією
  //     const activeActionProducts = allProducts.filter((product) => {
  //       return actions.some((action) => {
  //         const start = action.startDate ? new Date(action.startDate) : null;
  //         const end = new Date(action.endDate);

  //         const matchesProduct = action.appliesTo.products?.includes(
  //           product.id
  //         );

  //         // 🔑 Перевірка серій — товар може мати масив серій або одну серію
  //         const productSeries = Array.isArray(product.series)
  //           ? product.series
  //           : [product.series];
  //         const matchesSeries = productSeries.some((ser) =>
  //           action.appliesTo.series?.includes(ser)
  //         );

  //         // 🔑 Перевірка авторів — товар може мати масив авторів або одного автора
  //         const productAuthors = Array.isArray(product.author)
  //           ? product.author
  //           : [product.author];
  //         const matchesAuthor = productAuthors.some((a) =>
  //           action.appliesTo.authors?.includes(a)
  //         );

  //         return (
  //           (matchesProduct || matchesSeries || matchesAuthor) &&
  //           (!start || now >= start) &&
  //           now <= end
  //         );
  //       });
  //     });

  //     // 3️⃣ Об'єднуємо: старі sale + активні через акції, без дублів
  //     const combined = [
  //       ...saleProducts,
  //       ...activeActionProducts.filter(
  //         (p) => !saleProducts.some((sp) => sp.id === p.id)
  //       ),
  //     ];

  //     // 4️⃣ Випадковий вибір
  //     console.log("combined", combined);

  //     if (combined.length > 0) {
  //       const randomIndex = Math.floor(Math.random() * combined.length);
  //       setRandomProduct(combined[randomIndex]);
  //     } else {
  //       setRandomProduct(null);
  //     }
  //   }
  // }, [allProducts, actions, saleProducts]);
  useEffect(() => {
    if (allProducts.length && actions.length) {
      const now = new Date();

      const activeActionProducts = allProducts.flatMap((product) => {
        const matchedAction = actions.find((action) => {
          const start = action.startDate ? new Date(action.startDate) : null;
          const end = new Date(action.endDate);

          const matchesProduct = action.appliesTo.products?.includes(
            product.id
          );

          const productSeries = Array.isArray(product.series)
            ? product.series
            : [product.series];
          const matchesSeries = productSeries.some((ser) =>
            action.appliesTo.series?.includes(ser)
          );

          const productAuthors = Array.isArray(product.author)
            ? product.author
            : [product.author];
          const matchesAuthor = productAuthors.some((a) =>
            action.appliesTo.authors?.includes(a)
          );

          return (
            (matchesProduct || matchesSeries || matchesAuthor) &&
            (!start || now >= start) &&
            now <= end
          );
        });

        if (matchedAction) {
          return {
            ...product,
            actionDiscountPercent: matchedAction.discountPercent,
          };
        } else {
          return [];
        }
      });

      // 3️⃣ Об'єднуємо: старі sale + активні через акції, без дублів
      const combined = [
        ...saleProducts,
        ...activeActionProducts.filter(
          (p) => !saleProducts.some((sp) => sp.id === p.id)
        ),
      ];

      if (combined.length > 0) {
        const randomIndex = Math.floor(Math.random() * combined.length);
        setRandomProduct(combined[randomIndex]);
      } else {
        setRandomProduct(null);
      }
    }
  }, [allProducts, actions, saleProducts]);

  // 5️⃣ Перехід до каталогу з фільтром
  const goToSales = () => {
    dispatch(addFilter({ field: "sale", value: "true" }));
    navigate("/catalog");
  };

  return (
    <div className={css.oneProdWrapNew}>
      <p className={css.nameOfAcr} onClick={goToSales}>
        Всі Акції
      </p>

      {randomProduct ? (
        <SmallProductCart
          el={randomProduct}
          setCartCounterC={setCartCounterC}
          setLikeCounterC={setLikeCounterC}
        />
      ) : (
        <p>Акційних товарів зараз немає</p>
      )}
    </div>
  );
};

export default WithFieldData("sale", "product", "true")(OneProdActions);
